import { IconWrapper } from "@insite/mobius/Icon";
import { paginationStyles } from "@tps/Overrides/Widgets/ProductList/ProductListPagination";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

paginationStyles.pagination = {
    mergeCss: true,
    cssOverrides: {
        pagination: css`
            display: flex;
            justify-content: space-between;
        `,
        perPageSelect: css`
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    selectProps: {
        mergeCss: true,
        cssOverrides: {
            formField: css``,
            formInputWrapper: css`
                max-width: unset;
                width: auto;
                &&&& {
                    select {
                        padding-right: 25px;
                        ${xScreen("lte", "1024")} {
                            height: 34px;
                        }
                    }
                    ${IconWrapper} {
                        padding-right: 11px;
                    }
                    [aria-expanded="true"] ~ ${IconWrapper} {
                        padding-right: 5px;
                        padding-left: 11px;
                    }
                }
            `,
        },
        labelProps: {
            css: css`
                width: auto;
                padding: 3px 8px 0 0;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
    },
};
